import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Importando useNavigate
import ActionButtonCard from '../components/Button/ActionButtonCard'
import BuscarLembretes from '../components/Widgets/BuscarLembretes'
import Perfil from '../components/Widgets/Perfil'
import QuoteCard from '../components/Widgets/QuoteCard'
import BarraMetasDoMes from '../components/Widgets/BarraMetasDoMes'
import Metas from '../components/Widgets/Metas'
import AbrirApp from '../components/Button/AbrirApp'
import { Modal, Button } from 'react-bootstrap';
import { useProvider } from '../context/MenuProvider';

import AOS from "aos";
import 'aos/dist/aos.css';

const Home = () => {
  const navigate = useNavigate();
  const { 
    setLinks, 
    setBtns,
    hasPerms,
    atalhos,
    setTour,
    site,
  } = useProvider();
  
  useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  
  useEffect(() => {
      const tour = {
        id:"homeeshh",
        lista:[
          {
            id: "#gvendas",
            titulo: `Seja bem vindo ao App ${site?.nome_curto}`,
            descricao: `Vou te apresentar algumas das principais funcões desta tela do App ${site?.name}, me acompanhe...`,
            prev: false,
            next: true,
            finish: false
          },
          {
            id: "#menuPrincipal",
            titulo: "Menu Principal",
            descricao: "Aqui você abre o menu principal do App com os principais atalhos e funcionalidades.",
            prev: false,
            next: true,
            finish: false
          },
          {
            id: "#btnSync",
            titulo: "Lista de soncronização",
            descricao: "Aqui você ver todas as atividades pendentes de sincronização com o servidor.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#btnConfig",
            titulo: "Configurações",
            descricao: "Aqui você vai para área de configurações do sistema.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#infoBackup",
            titulo: "Backup de segurança",
            descricao: "Aqui você ver quando foi o último backup dos seus dados enviados para seu email.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#groupSupHome",
            titulo: "Acesso Rápido",
            descricao: "Aqui você ver os botões de acesso rápido às funções desejadas.",
            prev: true,
            next: true,
            finish: false
          },
          ...(hasPerms(['rede.view_frasedodia']) ? [{
            id: "#groupFrase",
            titulo: "Frase do dia",
            descricao: "Aqui você ver a frase motivacional do dia.",
            prev: true,
            next: true,
            finish: false
          }]:[]),
          ...(hasPerms(['loja.view_agenda','loja.view_clientes','loja.view_pagamento']) ? [{
            id: "#groupLembretes",
            titulo: "Lembretes",
            descricao: "Aqui você ver os principais lembretes para o dia.",
            prev: true,
            next: true,
            finish: false
          }]:[]),
          {
            id: "#groupFothHome",
            titulo: "Outros Acessos Rápido",
            descricao: "Aqui você ver os outros botões de acesso rápido às funções secundárias mais desejadas.",
            prev: true,
            next: true,
            finish: false
          },
          ...(hasPerms(['loja.view_metamensal', 'loja.add_metamensal']) ? [{
            id: "#groupMeta",
            titulo: "Resumo das Metas",
            descricao: "Aqui você ver o resumo das metas do mês atual.",
            prev: true,
            next: true,
            finish: false
          }]:[]),
          {
            id: "#menuRodape",
            titulo: "Menu Rodapé",
            descricao: "Aqui você ver os botões de principais acessos rápido.",
            prev: true,
            next: false,
            finish: true
          },
        ]
      }
      setLinks([
        // { name: 'Nova Venda', to: '/vendas/novo' },
        // { name: 'Novo Produto', to: '/produtos/novo' },
        // { name: 'Novo Cliente', to: '/clientes/novo' },
        //{ name: 'Configurações', to: '/configuracoes' },
      ]);
      setBtns([
        {icon:'bi-arrow-repeat', to:`/painel/sync`, id:"btnSync"},
        {icon:'bx bx-cog', to:`/config`, id:"btnConfig"},
      ]);
      setTour(tour);
      return () => {setLinks([]); setBtns([]); setTour({});}
  }, [setLinks, setBtns, setTour]);
  
  

  const menuTopoItens = parseInt(atalhos?.home_topo?.length || 0) >0 ? atalhos?.home_topo : [
    { path: "/checkout/selecionar-cliente", icone: "bx bx-cart-add", nome: "Nova Venda", nome_curto: "Venda", perms: ["loja.add_venda",], ativo:true },
    { path: "/produtos", icone: "bx bx-package", nome: "Estoque", nome_curto: "Produtos", perms: ["loja.view_produtos",], ativo:true },
    { path: "/contatos/novo/cliente?enviar_whatsapp=true", icone: "bx bx-user-plus", nome: "Novo Cliente", nome_curto: "Cliente", perms: ["loja.add_clientes",], ativo:true },
    { path: "/painel/apresentacoes", icone: "bx bx-slideshow", nome: "Slides", nome_curto: "Slides", perms: ["rede.view_apresentacao"], ativo:true },
    { path: "/rede/apn/novo", icone: "bx bx-book-add", nome: "Novo Plano", nome_curto: "APN", perms: ["rede.add_apn",], ativo:true },
    { path: "/despesas/novo/pessoais,negocio", icone: "bx bx-dollar-circle", nome: "Nova Despesa", nome_curto: "Despesa", perms: ["financas.add_financeiro",], ativo:true },
  ];
  const filteredItems = menuTopoItens.filter(item => (!item.perms?.length || hasPerms(item.perms)) && item.ativo);
  const menuTopo = filteredItems.slice(0, parseInt(atalhos?.home_topo?.length || 0) >0 ? 6 : 3);
  
  const menuItemsMeio = parseInt(atalhos?.home_meio?.length || 0) >0 ? atalhos?.home_meio :[
    { path: "/pagamentos/receita/todos", icone: "bx bx-money-withdraw", nome_curto: "Recebimentos", perms: ["loja.view_venda",], ativo:true },
    { path: "/pagamentos/despesa/negocio,pessoais", icone: "bx bx-wallet-alt", nome_curto: "Despesas", perms: ["financas.view_financeiro",], ativo:true },
    { path: "/relatorios", icone: "bx bx-food-menu", nome_curto: "Relatórios", perms: [
      "loja.view_metamensal",
    ], ativo:true },
    { path: "/painel/meu-mapa", icone: "bx bx-map-alt", nome_curto: "Meu Mapa", perms: ["core.view_localizacao",], ativo:true },
    { path: "/mensagens", icone: "bx bx-chat", nome_curto: "Mensagens", perms: ["core.view_whatsappmensagem"], ativo:true },
    { path: "/painel/feedback", icone: "bx bx-notepad", nome_curto: "Feedback", perms: ["feedback.view_feedback", "feedback.change_feedback", "feedback.add_feedback", "feedback.delete_feedback"], ativo:true },
    { path: "/clientes/checagem-de-inadimplencia", icone: "bx bx-check-shield", nome_curto: "Proteção", perms: ["loja.view_clientes"], ativo:true },
    
    { path: "/painel/loja", icone: "bx bx-tachometer", nome_curto: "Loja", perms: [`Loja`], ativo:true },
    { path: "/painel/gestao/financas", icone: "bx bx-dollar", nome_curto: "Finanças", perms: [
      "financas.view_financeiro",
    ], ativo:true },
    { path: "/agenda", icone: "bx bx-calendar", nome_curto: "Agenda", perms: ["loja.view_agenda",], ativo:true },
    { path: "/painel/gestao/rede", icone: "bx bx-sitemap", nome_curto: "Rede", perms: [
      "rede.view_prospecto",
    ], ativo:true },
    { path: "/painel/gestao/vendas", icone: "bx bx-shopping-bag", nome_curto: "Vendas", perms: [
      "loja.view_produtos",
    ], ativo:true },
    
    { path: "/config", icone: "bx bx-cog", nome_curto: "Config", perms: null, ativo:true },
    { path: "/painel/perfil", icone: "bx bx-user", nome_curto: "Perfil", perms: null, ativo:true },
    
    { path: "/painel/push-admin", icone: "bx bx-map-alt", nome_curto: "Push", perms: ["core.add_push","core.change_push","core.view_push","core.delete_push"], ativo:true },
  ];

  const filteredBtnsTopo = menuTopo.filter(item => !item.perms?.length || hasPerms(item.perms));
  const filteredBtnsMeio = menuItemsMeio.filter(item => !item.perms?.length || hasPerms(item.perms));
  

  return (
    <div data-aos="fade-up pb-5">
      <AbrirApp  />
      <Perfil />
      <div id="groupSupHome" className="row align-items-center">
          {filteredBtnsTopo.map((item, index) => (
            <ActionButtonCard 
              delay={index*2}
              key={index}
              to={item.path}
              icon={item.icone} 
              label={item.nome_curto}
              footer={item.nome}
            />
          ))}
      </div>

      {hasPerms(['rede.view_frasedodia']) && (<>
        <div id="groupFrase" data-aos="fade-up" data-aos-delay={100} className="border-top py-2 mt-3">
          <div className="">
            <QuoteCard/>
          </div>
        </div>
      </>)}
      {hasPerms(['loja.view_agenda','loja.view_clientes','loja.view_pagamento']) && (<>
        <div id="groupLembretes" data-aos="fade-up" data-aos-delay={200} className="border-top py-3 mb-3">
          <h4>Lembretes</h4>
          <BuscarLembretes   />
        </div>
      </>)}
      <div id="groupFothHome" className="border-top py-3 mt-3" data-aos-delay={300}>
        <div className="d-flex flex-nowrap overflow-auto">
          {filteredBtnsMeio.map((item, index) => (
            <ActionButtonCard 
              delay={index*2}
              key={index}
              col="col-4 mx-1"
              to={item.path}
              icon={item.icone} 
              text={item.nome_curto}
            />
          ))}
        </div>
      </div>
      {hasPerms(['loja.view_metamensal', 'loja.add_metamensal']) && (<>
        <div id="groupMeta" data-aos="fade-up">
            <Metas/>
        </div>
      </>)}
    </div>
  );
};

export default Home;